<template>
    <span style="width: 22px;flex-shrink: 0;">
      <!-- 轻量化图标 -->
      <img v-if="isWaiting" title="未轻量化" :src="require('@/commonAssets/projectMg/notlightweight.png')" class="lightStyle" @click.stop="updateLight(row, 0)" />
      <img v-if="isSuccess" :src="require('@/commonAssets/projectMg/icon_visual.png')" class="lightStyle" title="轻量化成功,点击重新轻量化" @click.stop="handleProcessing" />
      <img v-if="isFail" :src="require('@/commonAssets/projectMg/icon_visua_error.png')" class="lightStyle" :title="errorMsg" @click.stop="updateLight(row, 0)" />
      <img
        v-if="isDealing"
        :src="require('@/commonAssets/projectMg/Inlightweight.png')"
        style="
          transform: translateY(-50%);
          cursor: pointer;
          animation: rotating 2s linear infinite;
        "
        title="轻量化中"
        @click.stop="handleProcessing"
      />
    </span>
  </template>
  
  <script>
  import { common2D3DFileType } from "@/CommonDP/utils/docPublic";
  export default {
    props: {
      row: {
        type: Object,
        default: () => {},
      },
    },
  
    computed: {
      isWaiting() {
        const row = this.row;
        row.status = row.status?.toString();
        return (
          common2D3DFileType(row) && (row.status === "1" || row.status === "5" || row.status === "99")
          // 99 服务器可能挂了(后台给的)
        );
      },
  
      isSuccess() {
        const row = this.row;
        row.status = row.status?.toString();
        return common2D3DFileType(row) && (row.status === "2" || row.status === "6");
      },
  
      isFail() {
        const row = this.row;
        row.status = row.status?.toString();
        return common2D3DFileType(row) && (row.status === "3" || row.status === "7");
      },
  
      isDealing() {
        const row = this.row;
        row.status = row.status?.toString();
        return common2D3DFileType(row) && (row.status === "4" || row.status === "8");
      },
  
      errorMsg() {
        const row = this.row;
        return row.errorInfo
          ? `失败原因:${row.errorInfo},点击重新轻量化`
          : `轻量化失败,点击重新轻量化`;
      },
    },
  
    methods: {
      handleProcessing() {
        this.$message.warning('无需再次轻量化')
      },
      updateLight(row, flag) {
        this.$emit("updateLight", row, flag, this.isSuccess);
      },
    },
  };
  </script>
<style lang="scss" scoped>
.lightStyle {
  cursor: pointer;
  padding:7px 1px 0 3px;
  width: 22px;
  object-fit: scale-down;
}
</style>
  